var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sip-subscription" },
    [
      _c("sip-page-intro", {
        attrs: {
          title: _vm.trans("subscription.subscription"),
          badge: "Subscription",
          "badge-tone": "emerald",
          breadcrumbs: [
            { label: "Subscription" },
            { label: _vm.trans("subscription.subscription") },
          ],
          description: _vm.trans("subscription.module_info_title"),
        },
      }),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "sip-subscription-current",
          attrs: { "aria-label": "Current subscription" },
        },
        [
          _c("div", { staticClass: "sip-subscription-current__head" }, [
            _c("div", { staticClass: "sip-subscription-current__status" }, [
              _c(
                "span",
                {
                  staticClass: "sip-subscription-status-icon",
                  class:
                    _vm.instance.status === "running"
                      ? "is-live"
                      : "is-expired",
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c("em", {
                    class:
                      _vm.instance.status === "running"
                        ? "icon ni ni-check-circle-fill"
                        : "icon ni ni-cross-circle-fill",
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "sip-subscription-current__title-row" },
                  [
                    _c(
                      "h4",
                      { staticClass: "sip-subscription-current__plan" },
                      [_vm._v(_vm._s(_vm.instance.plan.name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "sip-badge",
                        class:
                          _vm.instance.status === "running"
                            ? "badge-success"
                            : "badge-danger",
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.trans(
                                "subscription." +
                                  (_vm.instance.status === "running"
                                    ? "live"
                                    : "expired")
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.instance.is_trial
                      ? _c("span", { staticClass: "sip-badge badge-warning" }, [
                          _vm._v(_vm._s(_vm.trans("subscription.trial"))),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "sip-subscription-current__price" }, [
                  _vm._v(_vm._s(_vm.getPrice)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "sip-subscription-current__expiry" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.trans("subscription.till")) +
                      " " +
                      _vm._s(_vm._f("moment")(_vm.instance.date_of_expiry)) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sip-subscription-current__actions" }, [
              _c(
                "button",
                {
                  staticClass:
                    "sip-subscription-btn sip-subscription-btn--primary",
                  class: { "is-active": _vm.activeFlow === "extend" },
                  attrs: { type: "button" },
                  on: { click: _vm.openExtendFlow },
                },
                [
                  _c("em", { staticClass: "icon ni ni-calendar-check" }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.trans("subscription.extend_subscription")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "sip-subscription-btn sip-subscription-btn--secondary",
                  class: { "is-active": _vm.activeFlow === "upgrade" },
                  attrs: { type: "button" },
                  on: { click: _vm.openUpgradeFlow },
                },
                [
                  _c("em", { staticClass: "icon ni ni-arrow-up-circle" }),
                  _vm._v(" "),
                  _vm.instance.status === "running"
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.trans("subscription.upgrade"))),
                      ])
                    : _c("span", [
                        _vm._v(_vm._s(_vm.trans("subscription.choose_plan"))),
                      ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sip-subscription-current__body" }, [
            _c("div", { staticClass: "sip-subscription-metric" }, [
              _c("span", { staticClass: "sip-subscription-metric__label" }, [
                _vm._v(_vm._s(_vm.trans("subscription.student_limit"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sip-subscription-metric__value" }, [
                _c("strong", [_vm._v(_vm._s(_vm.student_count))]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "/ " +
                      _vm._s(_vm.instance.max_student) +
                      " (" +
                      _vm._s(_vm.getStudentLimit) +
                      "%)"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sip-subscription-progress" }, [
                _c("div", {
                  staticClass: "sip-subscription-progress__bar",
                  class: "is-" + _vm.getProgressColor(_vm.getStudentLimit),
                  style: { width: _vm.getStudentLimit + "%" },
                  attrs: {
                    role: "progressbar",
                    "aria-valuenow": _vm.getStudentLimit,
                    "aria-valuemin": "0",
                    "aria-valuemax": "100",
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("dl", { staticClass: "sip-subscription-details" }, [
              _c("div", { staticClass: "sip-subscription-details__item" }, [
                _c("dt", [_vm._v(_vm._s(_vm.trans("subscription.domain")))]),
                _vm._v(" "),
                _c("dd", [_vm._v(_vm._s(_vm.instance.domain))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sip-subscription-details__item" }, [
                _c("dt", [_vm._v(_vm._s(_vm.trans("subscription.email")))]),
                _vm._v(" "),
                _c("dd", [_vm._v(_vm._s(_vm.instance.email))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sip-subscription-details__item" }, [
                _c("dt", [
                  _vm._v(_vm._s(_vm.trans("subscription.created_at"))),
                ]),
                _vm._v(" "),
                _c("dd", [
                  _vm._v(
                    _vm._s(_vm._f("momentDateTime")(_vm.instance.created_at))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sip-subscription-details__item" }, [
                _c("dt", [
                  _vm._v(_vm._s(_vm.trans("subscription.updated_at"))),
                ]),
                _vm._v(" "),
                _c("dd", [
                  _vm._v(
                    _vm._s(_vm._f("momentDateTime")(_vm.instance.updated_at))
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeFlow === "extend",
              expression: "activeFlow === 'extend'",
            },
          ],
          staticClass: "sip-subscription-flow",
          attrs: { "aria-label": "Extend or renew subscription" },
        },
        [
          _c("div", { staticClass: "sip-subscription-section-head" }, [
            _c("div", [
              _c(
                "h4",
                { staticClass: "sip-subscription-section-head__title" },
                [_vm._v(_vm._s(_vm.trans("subscription.extend_subscription")))]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sip-subscription-section-head__sub" }, [
                _vm._v(_vm._s(_vm.trans("subscription.extend_renew_subtitle"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "sip-subscription-flow__close",
                attrs: { type: "button", "aria-label": "Close" },
                on: { click: _vm.closeFlow },
              },
              [_c("em", { staticClass: "icon ni ni-cross" })]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sip-subscription-flow__toolbar" }, [
            _c("div", { staticClass: "sip-subscription-flow__toolbar-group" }, [
              _c(
                "span",
                { staticClass: "sip-subscription-flow__toolbar-label" },
                [_vm._v(_vm._s(_vm.trans("subscription.frequency")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "sip-subscription-toggle-group sip-subscription-toggle-group--with-badge",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "sip-subscription-toggle",
                      class: {
                        "is-active":
                          _vm.subscriptionForm.frequency === "monthly",
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.changeFrequency("monthly")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.trans("subscription.monthly")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "sip-subscription-toggle",
                      class: {
                        "is-active":
                          _vm.subscriptionForm.frequency === "annually",
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.changeFrequency("annually")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.trans("subscription.annually")) +
                          "\n                        "
                      ),
                      _vm.extendAnnualSavings
                        ? _c(
                            "span",
                            {
                              staticClass: "sip-subscription-savings-badge",
                              attrs: {
                                title: _vm.getAnnualSavingsAmountLabel(
                                  _vm.extendAnnualSavings
                                ),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getAnnualSavingsBadgeLabel(
                                    _vm.extendAnnualSavings
                                  )
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sip-subscription-flow__toolbar-group" }, [
              _c(
                "span",
                { staticClass: "sip-subscription-flow__toolbar-label" },
                [_vm._v(_vm._s(_vm.trans("subscription.currency")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sip-subscription-toggle-group" },
                _vm._l(_vm.currencies, function (currency) {
                  return _c(
                    "button",
                    {
                      key: currency.id,
                      staticClass:
                        "sip-subscription-toggle sip-subscription-toggle--compact",
                      class: {
                        "is-active": currency.id == _vm.selected_currency.id,
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.changeCurrency(currency)
                        },
                      },
                    },
                    [_vm._v(_vm._s(currency.name))]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sip-subscription-kpis" }, [
            _c("div", { staticClass: "sip-subscription-kpi" }, [
              _c("span", { staticClass: "sip-subscription-kpi__label" }, [
                _vm._v(_vm._s(_vm.trans("subscription.plan"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "sip-subscription-kpi__value" }, [
                _vm._v(_vm._s(_vm.instance.plan.name)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "sip-subscription-kpi sip-subscription-kpi--accent",
              },
              [
                _c("span", { staticClass: "sip-subscription-kpi__label" }, [
                  _vm._v(_vm._s(_vm.trans("subscription.payable"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "sip-subscription-kpi__value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatMultiCurrency(
                        _vm.subscriptionForm.amount,
                        _vm.selected_currency
                      )
                    )
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "sip-subscription-kpi" }, [
              _c("span", { staticClass: "sip-subscription-kpi__label" }, [
                _vm._v(_vm._s(_vm.trans("subscription.validity"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "sip-subscription-kpi__value" }, [
                _vm._v(
                  _vm._s(_vm._f("moment")(_vm.subscriptionForm.new_validity))
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sip-subscription-payment" }, [
            _c(
              "form",
              {
                staticClass: "sip-subscription-payment__form",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.proceed.apply(null, arguments)
                  },
                  keydown: function ($event) {
                    return _vm.subscriptionForm.errors.clear($event.target.name)
                  },
                },
              },
              [
                _vm.hasPaymentMethods
                  ? _c(
                      "div",
                      { staticClass: "sip-subscription-payment__methods" },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "sip-subscription-payment__methods-label",
                          },
                          [_vm._v("Payment method")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "sip-subscription-method-grid" },
                          [
                            _vm.config.subscription_paypal
                              ? _c(
                                  "label",
                                  { staticClass: "sip-subscription-method" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.subscriptionForm.method,
                                          expression: "subscriptionForm.method",
                                        },
                                      ],
                                      attrs: {
                                        type: "radio",
                                        value: "paypal",
                                        name: "method",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.subscriptionForm.method,
                                          "paypal"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.subscriptionForm.errors.clear(
                                            "method"
                                          )
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.subscriptionForm,
                                            "method",
                                            "paypal"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("PayPal")]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.config.subscription_stripe
                              ? _c(
                                  "label",
                                  { staticClass: "sip-subscription-method" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.subscriptionForm.method,
                                          expression: "subscriptionForm.method",
                                        },
                                      ],
                                      attrs: {
                                        type: "radio",
                                        value: "stripe",
                                        name: "method",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.subscriptionForm.method,
                                          "stripe"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.subscriptionForm.errors.clear(
                                            "method"
                                          )
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.subscriptionForm,
                                            "method",
                                            "stripe"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Stripe")]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.config.subscription_two_checkout
                              ? _c(
                                  "label",
                                  { staticClass: "sip-subscription-method" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.subscriptionForm.method,
                                          expression: "subscriptionForm.method",
                                        },
                                      ],
                                      attrs: {
                                        type: "radio",
                                        value: "two_checkout",
                                        name: "method",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.subscriptionForm.method,
                                          "two_checkout"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.subscriptionForm.errors.clear(
                                            "method"
                                          )
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.subscriptionForm,
                                            "method",
                                            "two_checkout"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("2Checkout")]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.config.subscription_razorpay &&
                            _vm.selected_currency.name == "INR" &&
                            _vm.razorpay_loaded
                              ? _c(
                                  "label",
                                  { staticClass: "sip-subscription-method" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.subscriptionForm.method,
                                          expression: "subscriptionForm.method",
                                        },
                                      ],
                                      attrs: {
                                        type: "radio",
                                        value: "razorpay",
                                        name: "method",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.subscriptionForm.method,
                                          "razorpay"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.subscriptionForm.errors.clear(
                                            "method"
                                          )
                                        },
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.subscriptionForm,
                                            "method",
                                            "razorpay"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Razorpay")]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.subscriptionForm,
                            "prop-name": "method",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.subscriptionForm.method
                  ? _c("div", [
                      _vm.subscriptionForm.method === "stripe"
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.card_number,
                                      expression: "card_number",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    maxlength: "16",
                                    placeholder: _vm.trans(
                                      "subscription.card_number"
                                    ),
                                  },
                                  domProps: { value: _vm.card_number },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.card_number = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-3" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.month,
                                      expression: "month",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    placeholder:
                                      _vm.trans("subscription.month"),
                                  },
                                  domProps: { value: _vm.month },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.month = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.year,
                                      expression: "year",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    placeholder: _vm.trans("subscription.year"),
                                  },
                                  domProps: { value: _vm.year },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.year = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-1" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.cvc,
                                      expression: "cvc",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    placeholder: _vm.trans("subscription.cvc"),
                                  },
                                  domProps: { value: _vm.cvc },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.cvc = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.subscriptionForm.method == "two_checkout",
                              expression:
                                "subscriptionForm.method == 'two_checkout'",
                            },
                          ],
                          staticClass: "sip-subscription-card-element",
                        },
                        [_c("div", { attrs: { id: "card-element" } })]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sip-subscription-payment__actions" },
                        [
                          _vm.button
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "sip-subscription-btn sip-subscription-btn--primary sip-subscription-btn--proceed",
                                  attrs: { type: "submit" },
                                },
                                [
                                  _c("em", {
                                    staticClass: "icon ni ni-arrow-right",
                                  }),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.trans("general.proceed")) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          ref: "upgradePlansSection",
          staticClass: "sip-subscription-plans",
          attrs: { "aria-label": "Upgrade plans" },
        },
        [
          _c("div", { staticClass: "sip-subscription-section-head" }, [
            _c("div", [
              _c(
                "h4",
                { staticClass: "sip-subscription-section-head__title" },
                [_vm._v(_vm._s(_vm.trans("subscription.upgrade")))]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sip-subscription-section-head__sub" }, [
                _vm._v(
                  _vm._s(_vm.trans("subscription.upgrade_section_subtitle"))
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "sip-subscription-flow__toolbar sip-subscription-flow__toolbar--inline",
              },
              [
                _c(
                  "div",
                  { staticClass: "sip-subscription-flow__toolbar-group" },
                  [
                    _c(
                      "span",
                      { staticClass: "sip-subscription-flow__toolbar-label" },
                      [_vm._v(_vm._s(_vm.trans("subscription.frequency")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sip-subscription-toggle-group sip-subscription-toggle-group--with-badge",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "sip-subscription-toggle",
                            class: {
                              "is-active":
                                _vm.subscriptionForm.frequency === "monthly",
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.changeFrequency("monthly")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.trans("subscription.monthly")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "sip-subscription-toggle",
                            class: {
                              "is-active":
                                _vm.subscriptionForm.frequency === "annually",
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.changeFrequency("annually")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.trans("subscription.annually")) +
                                "\n                            "
                            ),
                            _vm.upgradeAnnualSavings
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "sip-subscription-savings-badge",
                                    attrs: {
                                      title: _vm.getAnnualSavingsAmountLabel(
                                        _vm.upgradeAnnualSavings
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getAnnualSavingsBadgeLabel(
                                          _vm.upgradeAnnualSavings
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.hasUpgradePlans
            ? _c(
                "div",
                { staticClass: "sip-subscription-plans__grid" },
                _vm._l(_vm.normalizedUpgradablePlans, function (plan) {
                  return _c(
                    "article",
                    {
                      key: plan.id,
                      staticClass: "sip-subscription-plan-card",
                      class: {
                        "is-current": plan.id === _vm.instance.plan_id,
                        "is-selected":
                          _vm.subscriptionForm.upgrade_plan_id == plan.id,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "sip-subscription-plan-card__head" },
                        [
                          _c(
                            "h5",
                            { staticClass: "sip-subscription-plan-card__name" },
                            [_vm._v(_vm._s(plan.name))]
                          ),
                          _vm._v(" "),
                          plan.id === _vm.instance.plan_id
                            ? _c(
                                "span",
                                { staticClass: "sip-badge badge-info" },
                                [_vm._v("Current")]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sip-subscription-plan-card__price" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "sip-subscription-plan-card__amount",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getPlanPrice(
                                    plan,
                                    _vm.subscriptionForm.frequency
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "sip-subscription-plan-card__features" },
                        [
                          _c("li", [
                            _c("em", {
                              staticClass: "icon ni ni-check-circle-fill",
                            }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.getPlanStudentLimit(plan)) +
                                " students\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("em", {
                              staticClass: "icon ni ni-check-circle-fill",
                            }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.trans("subscription.frequency")) +
                                ": " +
                                _vm._s(
                                  _vm.trans(
                                    "subscription." +
                                      _vm.subscriptionForm.frequency
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "sip-subscription-btn",
                          class:
                            plan.id === _vm.instance.plan_id
                              ? "sip-subscription-btn--secondary"
                              : "sip-subscription-btn--primary",
                          attrs: {
                            type: "button",
                            disabled: plan.id === _vm.instance.plan_id,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectUpgradePlan(plan.id)
                            },
                          },
                        },
                        [
                          plan.id === _vm.instance.plan_id
                            ? _c("span", [_vm._v("Current plan")])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.trans("subscription.upgrade"))
                                ),
                              ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              )
            : _c(
                "div",
                { staticClass: "sip-subscription-plans__empty sip-empty" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", { staticClass: "sip-empty__title" }, [
                    _vm._v(
                      _vm._s(_vm.trans("subscription.upgrade_empty_title"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "sip-empty__hint" }, [
                    _vm._v(
                      _vm._s(_vm.trans("subscription.upgrade_contact_hint"))
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.supportEmail
                    ? _c("div", { staticClass: "sip-empty__action" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "sip-subscription-btn sip-subscription-btn--primary",
                            attrs: {
                              href:
                                "mailto:" +
                                _vm.supportEmail +
                                "?subject=" +
                                encodeURIComponent(
                                  _vm.trans("subscription.upgrade")
                                ),
                            },
                          },
                          [
                            _c("em", { staticClass: "icon ni ni-mail" }),
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.trans("subscription.contact_support")
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.activeFlow === "upgrade" &&
                    _vm.subscriptionForm.upgrade_plan_id,
                  expression:
                    "activeFlow === 'upgrade' && subscriptionForm.upgrade_plan_id",
                },
              ],
              staticClass:
                "sip-subscription-flow sip-subscription-flow--nested",
            },
            [
              _c("div", { staticClass: "sip-subscription-kpis" }, [
                _c("div", { staticClass: "sip-subscription-kpi" }, [
                  _c("span", { staticClass: "sip-subscription-kpi__label" }, [
                    _vm._v(_vm._s(_vm.trans("subscription.plan"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "sip-subscription-kpi__value" }, [
                    _vm._v(_vm._s(_vm.selectedUpgradePlanName)),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "sip-subscription-kpi sip-subscription-kpi--accent",
                  },
                  [
                    _c("span", { staticClass: "sip-subscription-kpi__label" }, [
                      _vm._v(_vm._s(_vm.trans("subscription.payable"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "sip-subscription-kpi__value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatMultiCurrency(
                            _vm.subscriptionForm.amount,
                            _vm.selected_currency
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "sip-subscription-kpi" }, [
                  _c("span", { staticClass: "sip-subscription-kpi__label" }, [
                    _vm._v(_vm._s(_vm.trans("subscription.validity"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "sip-subscription-kpi__value" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("moment")(_vm.subscriptionForm.new_validity)
                      )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sip-subscription-payment" }, [
                _c(
                  "form",
                  {
                    staticClass: "sip-subscription-payment__form",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.proceed.apply(null, arguments)
                      },
                      keydown: function ($event) {
                        return _vm.subscriptionForm.errors.clear(
                          $event.target.name
                        )
                      },
                    },
                  },
                  [
                    _vm.hasPaymentMethods
                      ? _c(
                          "div",
                          { staticClass: "sip-subscription-payment__methods" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "sip-subscription-payment__methods-label",
                              },
                              [_vm._v("Payment method")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "sip-subscription-method-grid" },
                              [
                                _vm.config.subscription_paypal
                                  ? _c(
                                      "label",
                                      {
                                        staticClass: "sip-subscription-method",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.subscriptionForm.method,
                                              expression:
                                                "subscriptionForm.method",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            value: "paypal",
                                            name: "method_upgrade",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.subscriptionForm.method,
                                              "paypal"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.subscriptionForm.errors.clear(
                                                "method"
                                              )
                                            },
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.subscriptionForm,
                                                "method",
                                                "paypal"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("PayPal")]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.config.subscription_stripe
                                  ? _c(
                                      "label",
                                      {
                                        staticClass: "sip-subscription-method",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.subscriptionForm.method,
                                              expression:
                                                "subscriptionForm.method",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            value: "stripe",
                                            name: "method_upgrade",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.subscriptionForm.method,
                                              "stripe"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.subscriptionForm.errors.clear(
                                                "method"
                                              )
                                            },
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.subscriptionForm,
                                                "method",
                                                "stripe"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Stripe")]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.config.subscription_two_checkout
                                  ? _c(
                                      "label",
                                      {
                                        staticClass: "sip-subscription-method",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.subscriptionForm.method,
                                              expression:
                                                "subscriptionForm.method",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            value: "two_checkout",
                                            name: "method_upgrade",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.subscriptionForm.method,
                                              "two_checkout"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.subscriptionForm.errors.clear(
                                                "method"
                                              )
                                            },
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.subscriptionForm,
                                                "method",
                                                "two_checkout"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("2Checkout")]),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.config.subscription_razorpay &&
                                _vm.selected_currency.name == "INR" &&
                                _vm.razorpay_loaded
                                  ? _c(
                                      "label",
                                      {
                                        staticClass: "sip-subscription-method",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.subscriptionForm.method,
                                              expression:
                                                "subscriptionForm.method",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            value: "razorpay",
                                            name: "method_upgrade",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.subscriptionForm.method,
                                              "razorpay"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.subscriptionForm.errors.clear(
                                                "method"
                                              )
                                            },
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.subscriptionForm,
                                                "method",
                                                "razorpay"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Razorpay")]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.subscriptionForm,
                                "prop-name": "method",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.subscriptionForm.method
                      ? _c("div", [
                          _vm.subscriptionForm.method === "stripe"
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.card_number,
                                          expression: "card_number",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "number",
                                        maxlength: "16",
                                        placeholder: _vm.trans(
                                          "subscription.card_number"
                                        ),
                                      },
                                      domProps: { value: _vm.card_number },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.card_number = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3" }, [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.month,
                                          expression: "month",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "number",
                                        placeholder:
                                          _vm.trans("subscription.month"),
                                      },
                                      domProps: { value: _vm.month },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.month = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-4" }, [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.year,
                                          expression: "year",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "number",
                                        placeholder:
                                          _vm.trans("subscription.year"),
                                      },
                                      domProps: { value: _vm.year },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.year = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-1" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-4" }, [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.cvc,
                                          expression: "cvc",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "number",
                                        placeholder:
                                          _vm.trans("subscription.cvc"),
                                      },
                                      domProps: { value: _vm.cvc },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.cvc = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "sip-subscription-payment__actions",
                            },
                            [
                              _vm.button
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "sip-subscription-btn sip-subscription-btn--primary sip-subscription-btn--proceed",
                                      attrs: { type: "submit" },
                                    },
                                    [
                                      _c("em", {
                                        staticClass: "icon ni ni-arrow-right",
                                      }),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.trans("general.proceed")) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.config.subscription_two_checkout && _vm.activeFlow !== "extend"
        ? _c(
            "div",
            {
              staticClass:
                "sip-subscription-card-element sip-subscription-card-element--hidden",
            },
            [_c("div", { attrs: { id: "card-element-fallback" } })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "sip-subscription-history",
          class: { "is-empty": !_vm.displaySubscriptions.total },
          attrs: { "aria-label": "Subscription history" },
        },
        [
          _c("div", { staticClass: "sip-subscription-section-head" }, [
            _c("div", [
              _c(
                "h4",
                { staticClass: "sip-subscription-section-head__title" },
                [_vm._v(_vm._s(_vm.trans("subscription.history")))]
              ),
              _vm._v(" "),
              _vm.displaySubscriptions.total
                ? _c(
                    "p",
                    { staticClass: "sip-subscription-section-head__sub" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.trans("general.total_result_found", {
                              count: _vm.displaySubscriptions.total,
                              from: _vm.displaySubscriptions.from,
                              to: _vm.displaySubscriptions.to,
                            })
                          ) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.showDemoHistoryBanner
            ? _c(
                "p",
                { staticClass: "sip-subscription-history__demo-banner" },
                [
                  _c("span", { staticClass: "sip-badge badge-warning" }, [
                    _vm._v(_vm._s(_vm.trans("subscription.test_data"))),
                  ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.trans("subscription.test_data_banner")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.displaySubscriptions.total
            ? _c(
                "div",
                {
                  staticClass:
                    "table-responsive sip-subscription-history__table",
                },
                [
                  _c("table", { staticClass: "table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(
                            _vm._s(_vm.trans("subscription.invoice_number"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.plan"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.amount"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.validity"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.method"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("subscription.date"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Status")]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-end" }, [
                          _vm._v(_vm._s(_vm.trans("general.action"))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.displaySubscriptions.data,
                        function (subscription) {
                          return _c(
                            "tr",
                            {
                              key: subscription.uuid || subscription.id,
                              class: {
                                "is-demo-row":
                                  _vm.isDemoSubscription(subscription),
                              },
                            },
                            [
                              _c("td", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.getNumber(subscription))),
                                ]),
                                _vm._v(" "),
                                _vm.isDemoSubscription(subscription)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "sip-badge badge-warning sip-subscription-history__demo-badge",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.trans("subscription.test_data")
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(subscription.plan.name)),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatMultiCurrency(
                                      subscription.amount,
                                      subscription.currency
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moment")(subscription.validity)
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.toWord(subscription.source))),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moment")(subscription.created_at)
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "sip-badge",
                                    class: subscription.status
                                      ? "badge-success"
                                      : "badge-warning",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          subscription.status
                                            ? "Paid"
                                            : "Pending"
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "table-action" }, [
                                _vm.canDownloadInvoice(subscription)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "sip-row-actions sip-row-actions--icons",
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "sip-row-actions__icon-btn",
                                            attrs: {
                                              href: _vm.invoicePdfUrl(
                                                subscription
                                              ),
                                              target: "_blank",
                                              rel: "noopener",
                                              title: _vm.trans(
                                                "subscription.download_invoice"
                                              ),
                                              "aria-label": _vm.trans(
                                                "subscription.download_invoice"
                                              ),
                                            },
                                          },
                                          [
                                            _c("em", {
                                              staticClass:
                                                "icon ni ni-download",
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "sip-row-actions__icon-btn",
                                            attrs: {
                                              href: _vm.invoicePrintUrl(
                                                subscription
                                              ),
                                              target: "_blank",
                                              rel: "noopener",
                                              title: _vm.trans("general.print"),
                                              "aria-label":
                                                _vm.trans("general.print"),
                                            },
                                          },
                                          [
                                            _c("em", {
                                              staticClass:
                                                "icon ni ni-printer-fill",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "sip-subscription-history__no-action",
                                      },
                                      [_vm._v("—")]
                                    ),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.displaySubscriptions.total
            ? _c("p", { staticClass: "sip-subscription-history__empty" }, [
                _vm._v(
                  "\n            No invoices yet. Renewals and upgrades will appear here.\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.displaySubscriptions.total && !_vm.usingDemoHistoryFallback
            ? _c("pagination-record", {
                attrs: {
                  "page-length": _vm.filterSubscriptionForm.page_length,
                  records: _vm.subscriptions,
                },
                on: {
                  "update:pageLength": function ($event) {
                    return _vm.$set(
                      _vm.filterSubscriptionForm,
                      "page_length",
                      $event
                    )
                  },
                  "update:page-length": function ($event) {
                    return _vm.$set(
                      _vm.filterSubscriptionForm,
                      "page_length",
                      $event
                    )
                  },
                  updateRecords: _vm.getSubscriptions,
                },
                nativeOn: {
                  change: function ($event) {
                    return _vm.getSubscriptions.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sip-empty__well" }, [
      _c("em", { staticClass: "icon ni ni-arrow-up-circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }